export const singleCoordinates = [103.590372, 31.477109];
export const zoomLevelDefault = 3;
export const zoomLevelMedium = 8;
export const zoomLevelMin = 2;
export const zoomLevelMax = 18;

export enum LeftPanel {
  Empty = "",
  Layers = "layers",
  Events = "events",
  Locations = "locations",
  AddLocation = "addlocation",
  EditLocation = "editlocation",
  EditLocationSet = "editlocationset",
  UserSystem = "usersystem",
  MyShapes = "myShapes",
}

export enum RightPanel {
  Empty = "",
  Single = "single",
  Multiple = "multiple",
  Events = "events",
  Line = "line",
  Polygon = "polygon"
}

export enum LayerInfoModal {
  Empty = "",
  Flood = "flood",
  EarthQuake = "earthQuake",
}

export enum Option {
  HAZARD = "hazard",
  CLIMATE = "climate",
  EVENT = "event",
}

export const OccupancyOptions = [{
  name: "Administration"
}, {
  name: "Commercial service"
}, {
  name: "Public facility"
}, {
  name: "Construction industry"
}, {
  name: "Food production"
}, {
  name: "Agriculture"
}, {
  name: "Beverage production"
}, {
  name: "Tobacco processing"
}, {
  name: "Mining"
}, {
  name: "Steel production"
}, {
  name: "Foundry"
}, {
  name: "Rolling mill"
}, {
  name: "Retail"
}, {
  name: "Trading"
}, {
  name: "Storage facility"
}, {
  name: "Telecommunication"
}, {
  name: "Data processing"
}, {
  name: "Transportation services"
}, {
  name: "Repair"
}, {
  name: "Maintenance"
}, {
  name: "Utilities (excluding power generation)"
}, {
  name: "Wood processing"
}, {
  name: "Theatre"
}, {
  name: "Studio (film, television, radio)"
}, {
  name: "Circus"
}, {
  name: "Single Family"
}, {
  name: "Multi-Family"
}, {
  name: "Apartment"
}, {
  name: "Condominium"
}, {
  name: "Dormitory"
}, {
  name: "Retirement Home"
}, {
  name: "Student Housing"
}, {
  name: "Retail Store"
}, {
  name: "Shopping Mall"
}, {
  name: "Office Building"
}, {
  name: "Hotel"
}, {
  name: "Motel"
}, {
  name: "Warehouse"
}, {
  name: "Restaurant"
}, {
  name: "Supermarket"
}, {
  name: "Bank"
}, {
  name: "Cinema"
}, {
  name: "Light Manufacturing"
}, {
  name: "Heavy Manufacturing"
}, {
  name: "Chemical Plant"
}, {
  name: "Food Processing"
}, {
  name: "Textile Mill"
}, {
  name: "Printing Plant"
}, {
  name: "Brewery"
}, {
  name: "Crop Storage"
}, {
  name: "Grain Elevator"
}, {
  name: "Livestock Facility"
}, {
  name: "Dairy Farm"
}, {
  name: "Greenhouse"
}, {
  name: "Poultry Farm"
}, {
  name: "Fish Farm"
}, {
  name: "School"
}, {
  name: "University"
}, {
  name: "Hospital"
}, {
  name: "Clinic"
}, {
  name: "Government Building"
}, {
  name: "Fire Station"
}, {
  name: "Police Station"
}, {
  name: "Library"
}, {
  name: "Museum"
}, {
  name: "Residential/Commercial Combo"
}, {
  name: "Office/Retail Combo"
}, {
  name: "Live/Work Space"
}, {
  name: "Power Plant"
}, {
  name: "Water Treatment"
}, {
  name: "Telecom Facility"
}, {
  name: "Transportation Hub"
}, {
  name: "Airport"
}, {
  name: "Railway Station"
}, {
  name: "Resort"
}, {
  name: "Conference Center"
}, {
  name: "Casino"
}, {
  name: "Spa"
}, {
  name: "Theme Park"
}, {
  name: "Church"
}, {
  name: "Mosque"
}, {
  name: "Temple"
}, {
  name: "Synagogue"
}, {
  name: "Religious School"
}, {
  name: "Stadium"
}, {
  name: "Sports Hall"
}, {
  name: "Gym"
}, {
  name: "Swimming Pool"
}, {
  name: "Golf Course"
}, {
  name: "Recreation Center"
}]

export const OCCUPANCY: { [key: string]: string } = {
  "Administration": "Administration",
  "Commercial service": "Commercial service",
  "Public facility": "Public facility",
  "Construction industry": "Construction industry",
  "Food production": "Food production",
  "Agriculture": "Agriculture",
  "Beverage production": "Beverage production",
  "Tobacco processing": "Tobacco processing",
  "Mining": "Mining",
  "Steel production": "Steel production",
  "Foundry": "Foundry",
  "Rolling mill": "Rolling mill",
  "Retail": "Retail",
  "Trading": "Trading",
  "Storage facility": "Storage facility",
  "Telecommunication": "Telecommunication",
  "Data processing": "Data processing",
  "Transportation services": "Transportation services",
  "Repair": "Repair",
  "Maintenance": "Maintenance",
  "Utilities (excluding power generation)": "Utilities (excluding power generation)",
  "Wood processing": "Wood processing",
  "Theatre": "Theatre",
  "Studio (film, television, radio)": "Studio (film, television, radio)",
  "Circus": "Circus",
  "Single Family": "Single Family",
  "Multi-Family": "Multi-Family",
  "Apartment": "Apartment",
  "Condominium": "Condominium",
  "Dormitory": "Dormitory",
  "Retirement Home": "Retirement Home",
  "Student Housing": "Student Housing",
  "Retail Store": "Retail Store",
  "Shopping Mall": "Shopping Mall",
  "Office Building": "Office Building",
  "Hotel": "Hotel",
  "Motel": "Motel",
  "Warehouse": "Warehouse",
  "Restaurant": "Restaurant",
  "Supermarket": "Supermarket",
  "Bank": "Bank",
  "Cinema": "Cinema",
  "Light Manufacturing": "Light Manufacturing",
  "Heavy Manufacturing": "Heavy Manufacturing",
  "Chemical Plant": "Chemical Plant",
  "Food Processing": "Food Processing",
  "Textile Mill": "Textile Mill",
  "Printing Plant": "Printing Plant",
  "Brewery": "Brewery",
  "Crop Storage": "Crop Storage",
  "Grain Elevator": "Grain Elevator",
  "Livestock Facility": "Livestock Facility",
  "Dairy Farm": "Dairy Farm",
  "Greenhouse": "Greenhouse",
  "Poultry Farm": "Poultry Farm",
  "Fish Farm": "Fish Farm",
  "School": "School",
  "University": "University",
  "Hospital": "Hospital",
  "Clinic": "Clinic",
  "Government Building": "Government Building",
  "Fire Station": "Fire Station",
  "Police Station": "Police Station",
  "Library": "Library",
  "Museum": "Museum",
  "Residential/Commercial Combo": "Residential/Commercial Combo",
  "Office/Retail Combo": "Office/Retail Combo",
  "Live/Work Space": "Live/Work Space",
  "Power Plant": "Power Plant",
  "Water Treatment": "Water Treatment",
  "Telecom Facility": "Telecom Facility",
  "Transportation Hub": "Transportation Hub",
  "Airport": "Airport",
  "Railway Station": "Railway Station",
  "Resort": "Resort",
  "Conference Center": "Conference Center",
  "Casino": "Casino",
  "Spa": "Spa",
  "Theme Park": "Theme Park",
  "Church": "Church",
  "Mosque": "Mosque",
  "Temple": "Temple",
  "Synagogue": "Synagogue",
  "Religious School": "Religious School",
  "Stadium": "Stadium",
  "Sports Hall": "Sports Hall",
  "Gym": "Gym",
  "Swimming Pool": "Swimming Pool",
  "Golf Course": "Golf Course",
  "Recreation Center": "Recreation Center",
  "行政管理机构": "Administration",
  "商业服务": "Commercial service",
  "公共设施": "Public facility",
  "建筑业": "Construction industry",
  "食品生产": "Food production",
  "农业": "Agriculture",
  "饮料生产": "Beverage production",
  "烟草加工": "Tobacco processing",
  "采矿": "Mining",
  "钢铁生产": "Steel production",
  "铸造厂": "Foundry",
  "轧钢厂": "Rolling mill",
  "零售": "Retail",
  "贸易": "Trading",
  "仓储设施": "Storage facility",
  "电信": "Telecommunication",
  "数据处理/数据中心": "Data processing",
  "运输服务": "Transportation services",
  "维修行业": "Repair",
  "保养行业": "Maintenance",
  "公用事业（不含发电）": "Utilities (excluding power generation)",
  "木材加工": "Wood processing",
  "剧院": "Theatre",
  "演播室（电影、电视、广播）": "Studio (film, television, radio)",
  "马戏团": "Circus",
  "独栋别墅": "Single Family",
  "多户住宅联排别墅": "Multi-Family",
  "公寓（塔楼/板楼）": "Apartment",
  "商品房（塔楼/板楼）": "Condominium",
  "集体宿舍": "Dormitory",
  "养老院": "Retirement Home",
  "学生宿舍": "Student Housing",
  "零售店": "Retail Store",
  "购物中心": "Shopping Mall",
  "办公楼": "Office Building",
  "酒店": "Hotel",
  "汽车旅馆": "Motel",
  "仓库": "Warehouse",
  "餐厅": "Restaurant",
  "超市": "Supermarket",
  "银行": "Bank",
  "电影院": "Cinema",
  "轻工业制造": "Light Manufacturing",
  "重工业制造": "Heavy Manufacturing",
  "化工厂": "Chemical Plant",
  "食品加工厂": "Food Processing",
  "纺织厂": "Textile Mill",
  "印刷厂": "Printing Plant",
  "啤酒厂": "Brewery",
  "粮食储存": "Crop Storage",
  "粮仓": "Grain Elevator",
  "畜牧设施": "Livestock Facility",
  "奶牛场": "Dairy Farm",
  "温室": "Greenhouse",
  "家禽养殖场": "Poultry Farm",
  "鱼类养殖场": "Fish Farm",
  "学校": "School",
  "大学": "University",
  "医院": "Hospital",
  "诊所": "Clinic",
  "政府大楼": "Government Building",
  "消防站": "Fire Station",
  "警察局": "Police Station",
  "图书馆": "Library",
  "博物馆": "Museum",
  "住宅/商业混合体": "Residential/Commercial Combo",
  "办公/零售混合体": "Office/Retail Combo",
  "商住两用": "Live/Work Space",
  "发电厂": "Power Plant",
  "水处理厂": "Water Treatment",
  "电信设施": "Telecom Facility",
  "交通枢纽": "Transportation Hub",
  "机场": "Airport",
  "火车站": "Railway Station",
  "度假村": "Resort",
  "会议中心": "Conference Center",
  "赌场": "Casino",
  "水疗中心": "Spa",
  "主题公园": "Theme Park",
  "教堂": "Church",
  "清真寺": "Mosque",
  "寺庙": "Temple",
  "犹太教堂": "Synagogue",
  "宗教学校": "Religious School",
  "体育场": "Stadium",
  "体育馆": "Sports Hall",
  "健身房": "Gym",
  "游泳池": "Swimming Pool",
  "高尔夫球场": "Golf Course",
  "休闲中心": "Recreation Center",
}